<era-pane>
  <h5 class="small-caps"
      i18n>MdmOptions (Activation Lock Allowed While Supervised)</h5>
  <form [formGroup]="mdmOptionsForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="activationLockAllowedWhileSupervised"
               id="activationLockAllowedWhileSupervised" />
        <label class="form-check-label"
               for="activationLockAllowedWhileSupervised">Turn Activation Lock Allowed While Supervised
          {{ (activationLockAllowedWhileSupervised.valueChanges | async) ? 'On' : 'Off' }}</label>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!mdmOptionsForm.valid">Submit</button>
  </form>
</era-pane>